import React from 'react';

import { useJiraContext } from 'src/services/jira';

const ConfigureConnectionLink = ({ children }) => {
  const { settings: { v3Domain: { value: v3Domain } = {}, v3AddonId: { value: v3AddonId } = {} } } = useJiraContext();
  return <a href={`https://${v3Domain}/accounts_addons/${v3AddonId}`} target="_blank" rel="noopener noreferrer">{children}</a>;
};

export default ConfigureConnectionLink;
